import React, { FC } from "react";
import { FONT_SECONDARY } from "../../../theme/typography";
import { Box, Typography } from "@mui/material";
import palette from "../../../theme/palette";
import PrePaidEmptySvg from "../../../assets/svg-fc/PrePaidEmptySvg";

interface iPrePaidRequestEmptyProps {
	prePaidEmptyTitle: string;
	prePaidEmptyDescription: string;
}

const PrePaidRequestEmpty: FC<iPrePaidRequestEmptyProps> = ({
	prePaidEmptyTitle,
	prePaidEmptyDescription,
}) => {
	return (
		<>
			<Box
				className="pre_paid_empty_screen" sx={{ bgcolor: palette.background.paper, borderRadius: "12px", paddingBlock: "66px", paddingInline: "16px", display: "grid", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
				<Typography
					component="span" sx={{ width: "78px", height: "78px", borderRadius: "100%", overflow: "hidden", marginInline: "auto", marginBlockEnd: "22px" }}>
					<PrePaidEmptySvg />
				</Typography>
				<Typography
					component="h2" sx={{ color: palette.secondary.main, fontSize: "18px", fontWeight: 600, fontFamily: FONT_SECONDARY, marginBlockEnd: "12px" }}>
					{prePaidEmptyTitle}
				</Typography>
				<Typography
					component="p" sx={{ color: '#403F40', fontWeight: 500, textAlign: "center", maxWidth: "326px" }}>
					{prePaidEmptyDescription}
				</Typography>
			</Box>
		</>
	);
};
export default PrePaidRequestEmpty;
